/**
 * Utility functions for booking-related operations
 */

/**
 * Generate a booking URL with prefilled date and time parameters
 * @param {string} preferredDate - Date in YYYY-MM-DD format (e.g., "2024-03-27")
 * @param {string} preferredTime - Time slot (e.g., "morning", "afternoon", "evening", "night")
 * @returns {string} - URL with query parameters
 */
export const generateBookingUrl = (preferredDate, preferredTime) => {
  const baseUrl = '/book-appointment';
  const params = new URLSearchParams();
  
  if (preferredDate) {
    params.append('preferredDate', preferredDate);
  }
  
  if (preferredTime) {
    params.append('preferredTime', preferredTime);
  }
  
  const queryString = params.toString();
  return queryString ? `${baseUrl}?${queryString}` : baseUrl;
};

/**
 * Get today's date in YYYY-MM-DD format
 * @returns {string} - Today's date
 */
export const getTodayDate = () => {
  const today = new Date();
  return today.toISOString().split('T')[0];
};

/**
 * Get tomorrow's date in YYYY-MM-DD format
 * @returns {string} - Tomorrow's date
 */
export const getTomorrowDate = () => {
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  return tomorrow.toISOString().split('T')[0];
};

/**
 * Available time slots for pickup
 */
export const TIME_SLOTS = [
  { value: 'morning', label: 'Morning (9 AM - 12 PM)' },
  { value: 'afternoon', label: 'Afternoon (12 PM - 3 PM)' },
  { value: 'evening', label: 'Evening (3 PM - 6 PM)' },
  { value: 'night', label: 'Night (6 PM - 9 PM)' }
];

/**
 * Parse URL parameters for booking
 * @param {URLSearchParams} searchParams - URL search parameters
 * @returns {object} - Parsed booking parameters
 */
export const parseBookingParams = (searchParams) => {
  return {
    preferredDate: searchParams.get('preferredDate') || '',
    preferredTime: searchParams.get('preferredTime') || ''
  };
};
